import * as React from "react";
import { Box, Button, Typography, Modal } from "@mui/material";
import question from "../../Assets/Question.svg";
import TrialPeriodTable from "./ExtendDateComponent";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 12,
  p: 4,
  borderRadius: "35px",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

export default function ConfirmDeleteModal({
  open,
  handleClose,
  handleConfirm,
  title = "Are you sure?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "#164FA1",
  cancelColor = "#164FA1",
  subTitle,
}) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-description"
    >
      <Box sx={style}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img src={question} alt="modal-icon" />
        </Box>
       

        <Typography
          textAlign="center"
          id="confirm-modal-title"
          variant="h5"
          component="h2"
          mt={1}
        >
          {title}
        </Typography>
        {subTitle && <TrialPeriodTable extendDate={subTitle} />}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            gap: 2,
          }}
        >
          <Button
            fullWidth
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              color: cancelColor,
            }}
            variant="outlined"
            onClick={handleClose}
          >
            {cancelText}
          </Button>
          <Button
            variant="contained"
            fullWidth
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              backgroundColor: confirmColor,
              color: "white",
              "&:hover": {
                backgroundColor: confirmColor,
                color: "white",
              },
            }}
            onClick={handleConfirm}
          >
            {confirmText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
